<template>
  <div class="details-component__content content">
    <v-server-table :url="url" :columns="columns" :options="options">
      <span v-if="props.row.receipt_download" slot="receipt_download" slot-scope="props">
        <a :href="props.row.download_link" target="_blank">
          <div class="icon-download"></div>
        </a>
      </span>
      <span v-if="props.row.client_receipt_download" slot="client_receipt_download" slot-scope="props">
        <a :href="props.row.client_receipt_link" target="_blank">
          <div class="icon-download"></div>
        </a>
      </span>
    </v-server-table>
  </div>
</template>

<script>

import Vue from 'vue';
import { ServerTable } from 'vue-tables-2';

Vue.use(ServerTable);

export default {
  props: ['url'],
  data() {
    const self = this;
    const localLang = localStorage.getItem('locale');
    const DEF_LANG = 'en';
    return {
      columns: [
        'permit_nr', 'ticket_type', 'vehicle_nr', 'id_code', 'valid_from', 'valid_to',
        'permit_status', 'payment_status', 'total_sum', 'receipt_download', 'client_receipt_download',
      ],
      options: {
        perPage: 50,
        perPageValues: [],
        texts: {
          noResults: this.$t('tenants.no_matching_records'),
          count: this.$t('tables.count'),
        },
        filterable: false,
        sortable: [],
        rowClassCallback: () => 'VueTables__row',
        columnsClasses: {
          total_sum: 'left',
          receipt_download: 'center',
          client_receipt_download: 'center',
        },
        headings: {
          permit_nr: () => this.$t('kiosk_permits.permit_nr'),
          ticket_type: () => this.$t('kiosk_permits.ticket_type'),
          vehicle_nr: () => this.$t('kiosk_permits.vehicle_nr'),
          id_code: () => this.$t('kiosk_permits.id_code'),
          valid_from: () => this.$t('kiosk_permits.valid_from'),
          valid_to: () => this.$t('kiosk_permits.valid_to'),
          permit_status: () => this.$t('kiosk_permits.permit_status'),
          payment_status: () => this.$t('kiosk_permits.payment_status'),
          total_sum: () => this.$t('kiosk_permits.total_sum'),
          receipt_download: () => this.$t('kiosk_permits.receipt_download'),
          client_receipt_download: () => this.$t('kiosk_permits.client_receipt_download'),
        },
        requestFunction(data) {
          return Vue.http.get(self.url, { params: { page: data.page } });
        },
        responseAdapter(resp) {
          const body = resp.body;
          return {
            data: body.data.map(item => ({
              permit_nr: item.order_number,
              ticket_type: (item.kiosk_permit_type.name[localLang] !== undefined)
                ? item.kiosk_permit_type.name[localLang]
                : item.kiosk_permit_type.name[DEF_LANG],
              vehicle_nr: item.vehicle.vehicle_reg,
              id_code: item.id_code,
              valid_from: item.purchased_at,
              valid_to: item.expires_at,
              permit_status: item.active ? 'Active' : 'Expired',
              payment_status: item.transaction.state,
              total_sum: item.transaction.amount,
              receipt_download: item.transaction.has_receipt,
              download_link: item.transaction.has_receipt
                ? `${process.env.BACKEND_API_URL}v2/export/${item.id}/receipt?token=${localStorage.getItem('id_token')}`
                : '',
              client_receipt_download: item.transaction.has_client_receipt,
              client_receipt_link: item.transaction.has_client_receipt
                ? `${process.env.BACKEND_API_URL}v2/export/${item.id}/client-receipt?token=${localStorage.getItem('id_token')}`
                : '',
            })),
            count: body.meta.total,
          };
        },
      }
    }
  }
}
</script>

<style lang="scss">
@import '~styles/app.scss';

.icon-download {
  width: 100%;
  height: 20px;
}

.left {
  text-align: left;
}

.center {
  text-align: center;
}

.VueTables__sortable {
  span {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tenants/kiosk-permits/ui/PermitsList.vue